import ActionTypes from '../actions/types'
import { createReducer } from 'reduxsauce'
import Utils from '../utils/Utils'

const INITIAL_STATE = {
  alarms: []
}

const setAlarms = (state, action) => {
  const { alarms } = action.payload
  return {
    ...state,
    alarms
  }
}

const addAlarms = (state, action) => {
  const { alarms } = action.payload

  // Build index map for O(1) lookups
  const existingAlarmsMap = new Map(
    state.alarms.map((alarm, index) => [alarm.id, index])
  )

  // Merge alarms
  const updatedAlarms = [...state.alarms]
  const newAlarmsToAdd = []

  alarms.forEach(alarm => {
    const existingIndex = existingAlarmsMap.get(alarm.id)
    if (existingIndex !== undefined) {
      // Update existing alarm
      updatedAlarms[existingIndex] = alarm
    } else {
      // Queue new alarm for addition
      newAlarmsToAdd.push(alarm)
    }
  })

  return {
    ...state,
    alarms: [...updatedAlarms, ...newAlarmsToAdd]
  }
}

const addAlarm = (state, action) => {
  const { alarm } = action.payload
  const alarmIndex = Utils.getIndexOfObjectWithId(state.alarms, alarm.id)

  let newAlarms

  // New alarm
  if (alarmIndex === -1) {
    newAlarms = [...state.alarms, alarm]
  } else {
    // Update existing alarm
    newAlarms = state.alarms.map((a, index) =>
      index === alarmIndex ? alarm : a
    )
  }

  return {
    ...state,
    alarms: newAlarms
  }
}

const removeAlarm = (state, action) => {
  const { alarmId } = action.payload
  let alarmIndex = Utils.getIndexOfObjectWithId(state.alarms, alarmId)
  if (alarmIndex !== -1) {
    const newAlarms = state.alarms.filter((_, index) => index !== alarmIndex)
    return {
      ...state,
      alarms: newAlarms
    }
  } else {
    console.tron.log('Trying to delete a non-existing alarm')
    return state
  }
}

const ACTION_HANDLERS = {
  [ActionTypes.ADD_INCIDENT_ALARM]: addAlarm,
  [ActionTypes.ADD_INCIDENT_ALARMS]: addAlarms,
  [ActionTypes.SET_INCIDENT_ALARMS]: setAlarms,
  [ActionTypes.REMOVE_INCIDENT_ALARM]: removeAlarm
}

export default createReducer(INITIAL_STATE, ACTION_HANDLERS)
